import "./App.css";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue } from "firebase/database";
import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import Data from "./Data";
import Home from "./Home";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

const firebaseConfig = {
  apiKey: "AIzaSyCj--Ch1RXstXB9lHAyxaU1CKUx7JJk7P0",
  authDomain: "seefood-af63f.firebaseapp.com",
  projectId: "seefood-af63f",
  storageBucket: "seefood-af63f.appspot.com",
  messagingSenderId: "13229209191",
  appId: "1:13229209191:web:b7f20a225e56f6b93ec6c2",
  measurementId: "G-FQ14SEB8HB",
};

function App() {
  const app = initializeApp(firebaseConfig);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="data" element={<Data />} />
      </Routes>
    </>
  );
}

export default App;
